<template lang="pug">
    div(class="_po _con", :class="{ _rt: halign == 'right', _ar: arrow != 'none' }")
        slot
</template>

<script>
    import overlay from '../private/overlay'

    /**
     * An unstyled popover that exposes a slot to render inside of it.
     */
    export default {
        name: 'ib-popover',
        mixins: [overlay],

        mounted() {
            if (!this.$overlay()) {
                console.error('ib-popover: Instantiate with $overlay');
            }
        },

        props: {
            arrow: {
                type: String,
                default: 'up'
            }
        },

        methods: {
            /**
            * Emits 'show' event
            * @event
            * @type {null}
            */
            onShow() {
                this.$emit('show');
            },
            /**
            * Emits 'hide' event
            * @event
            * @type {null}
            */
            onHide() {
                this.$emit('hide');
            }
        }
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    ._po {
        position: fixed;
        display: flex;
        flex-direction: row;

        margin: 0;
        z-index: @z-popover;
        background: @bg-dialog;
        .elevation(6, 0, .6);

        & { /* visible */
            opacity: 1;
            transition: opacity .15s linear;
        }
        &.hidden {
            opacity: 0;
            transition: opacity .1s linear, visibility 0s linear .1s;
            visibility: hidden;
        }

        &._ar {
            &::before {
                content: '';
                position: absolute;
                top: -7px;
                left: 20px;
                width: 14px;
                height: 14px;
                background-color: inherit;
                pointer-events: none;
                z-index: -1;
                -webkit-clip-path: polygon(0 0, 100% 0, 0 100%);
                        clip-path: polygon(0 0, 100% 0, 0 100%);
                -webkit-transform: rotate(45deg);
                        transform: rotate(45deg);
            }
            &._ab::before {
                top: auto;
                bottom: -7px;
            }
            &._rt::before {
                left: auto;
                right: 20px;
            }
        }
    }
</style>

<docs>
    ```jsx
        new Vue({
            methods: {
                click() {
                    this.$refs.tooltip.anchor = this.$refs.btn;
                    this.$nextTick(() => this.$refs.tooltip.open());
                }
            },
            template: `
                <div>
                    <ib-button @click="click" ref="btn">Click Me</button>
                    <ib-popover ref="tooltip">
                        <div>
                            Hello world
                        </div>
                    </ib-popover>
                </div>
            `
        });
    ```
</docs>
